module.exports = __webpack_public_path__ + "static/img/naiyou.c5cc8707.png";